import './CommentsBoxReadonly.css';

import React from 'react';

export interface CommentsBoxReadonlyProps {
  title: string;
  value: string;
}

const CommentsBoxReadonly: React.FC<CommentsBoxReadonlyProps> = ({
  title,
  value,
}) => (
  <div className="comments-box-readonly">
    <h4 className="comments-readonly-title">{title}</h4>
    <div className="comments-textarea-readonly">
      {value ? (
        value
      ) : (
        <span className="comments-readonly-placeholder">No comments</span>
      )}
    </div>
  </div>
);

export default CommentsBoxReadonly;
